module.exports = __webpack_public_path__ + "2be408f6b329447826a3261dea95b1b1.glb";